<div class="error-dialog">
    <h1 mat-dialog-title>Ops!! Aconteceu um erro.</h1>
    <div *ngFor="let rest of restrictions"> 
        <div class="panel" *ngFor="let item of rest['reasons']">
            <div class="panel-header panel-danger">
                {{item.message}}
            </div>
            <div class="panel-body" *ngIf="item['links'] && item['links'].length > 0">
                <ul  *ngFor="let link of item['links']">
                    <li>{{link.title}}</li>
                    <li><a [href]="link.resource">{{link.resource}} </a></li>
                </ul>
            </div>
        </div>
    </div>
</div>
  